export const PASSWORD_REGEX =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}/;

export const USERNAME_REGEX = /^[a-zA-Z\u0600-\u06FF]+[0-9]*$/;
// ^([A-Za-z\u0621-\u064A][0-9]){3,20}*$
